import React from 'react'

import { Wrapper } from './styles'

const Splotch = props => <Wrapper {...props} className="splotchImage" />

export default Splotch
